import { useDispatch, useSelector } from 'react-redux';

import { TextView } from 'components';
import ButtonViewV3 from 'components/ButtonViewV3/ButtonViewV3';
import useChannelDetails, { channelsMap } from 'hooks/useChannelDetails';
import {
  addEmptyContentToTemplate,
  selectShouldEnableAddContentButton,
} from 'redux/content/content.slice';

import { ContentAccordions } from './ContentAccordions';

const ContentTemplateWrapper = () => {
  const { channel } = useChannelDetails();

  const shouldEnableAddContentButton = useSelector(
    selectShouldEnableAddContentButton(channel)
  );
  const dispatch = useDispatch();

  return (
    <div className="flex flex-col pt-4  gap-6 min-h-[619px] max-h-[619px]">
      <div className="flex flex-row gap-2 justify-between align-top">
        <div className="flex flex-col ">
          <div>
            <TextView
              textType="body"
              color="#101828"
              size={18}
              fontStyle="normal"
              weight="700"
              lineHeight={28}
              text={`Add content for your ${
                channelsMap[channel as keyof typeof channelsMap].name || ''
              } template`}
            />
          </div>
          <div>
            <TextView
              textType="body"
              color="#475467"
              size={14}
              fontStyle="normal"
              weight="400"
              lineHeight={20}
              text={`Select Language, ${
                channelsMap[channel as keyof typeof channelsMap].displayIdText
              }, Content, Variable and much more`}
            />
          </div>
        </div>
        <div className="flex w-fit ">
          <ButtonViewV3
            disabled={!shouldEnableAddContentButton}
            onClick={() => {
              dispatch(addEmptyContentToTemplate());
            }}
            label="Add Content"
            variant="secondary"
          />
        </div>
      </div>
      <ContentAccordions edit />
    </div>
  );
};

export default ContentTemplateWrapper;
